import ShimmerImage from 'core-lib/components/ShimmerImage';
import { Typography } from 'ui-v2/components/Typography';
import s from './DeliveryFeeStrip.module.scss';
import Cart from '../../types/cart';
import formatCurrency from 'core-lib/utils/currency';

type DeliverStripPropType = {
  text: string;
  icon: string;
  cartData?: Cart;
};

export const DeliveryFeeStrip = ({
  text,
  icon,
  cartData,
}: DeliverStripPropType) => {
  return (
    <div
      style={{
        background: '#05AF25',
      }}
      className={s.root}
    >
      <ShimmerImage
        src={
          icon ||
          'https://parkplus-bkt-img.parkplus.io/production/store/public/images_20241121170205934175.webp'
        }
        className={s.icon}
      />
      <Typography
        label={
          !text
            ? cartData?.newCartPrice < 299
              ? `You are ${formatCurrency(
                  299 - cartData?.newCartPrice
                )} away from FREE DELIVERY`
              : 'Yay! FREE DELIVERY unlocked!'
            : text
        }
        variant="label_3_medium"
        color="on_dark_bg"
      />
    </div>
  );
};
